var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-select",
    {
      staticStyle: { width: "100%" },
      attrs: { "popper-class": "cust-select-poper" },
      on: { change: _vm.handleChange },
      model: {
        value: _vm.accessType,
        callback: function ($$v) {
          _vm.accessType = $$v
        },
        expression: "accessType",
      },
    },
    [
      _c(
        "el-option",
        { attrs: { label: _vm.$t("ALL_OPTION"), value: "ALL" } },
        [
          _c(
            "p",
            {
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.confirmValue.apply(null, arguments)
                },
              },
            },
            [
              _c("el-radio", {
                staticClass: "mr_10 label-hidden",
                attrs: { label: "ALL" },
                model: {
                  value: _vm.accessType,
                  callback: function ($$v) {
                    _vm.accessType = $$v
                  },
                  expression: "accessType",
                },
              }),
              _c("span", { staticClass: "option-label" }, [
                _vm._v(_vm._s(_vm.$t("ALL_OPTION"))),
              ]),
            ],
            1
          ),
          _vm.$i18n.locale === "en"
            ? [
                _c(
                  "p",
                  {
                    staticClass: "mr_25 desc",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.confirmValue.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n             User has access to all entities content across all tiles.\n              "
                    ),
                  ]
                ),
                _c("p", { staticClass: "mr_25 desc" }),
              ]
            : [
                _c(
                  "p",
                  {
                    staticClass: "mr_25 desc",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.confirmValue.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                  用户可以访问所有实体及所有功能版块中的内容。\n              "
                    ),
                  ]
                ),
              ],
        ],
        2
      ),
      _c(
        "el-option",
        { attrs: { label: _vm.$t("SPECIFIC_OPTION"), value: "SPECIFIC" } },
        [
          _c(
            "p",
            [
              _c("el-radio", {
                staticClass: "mr_10 label-hidden",
                attrs: { label: "SPECIFIC" },
                model: {
                  value: _vm.accessType,
                  callback: function ($$v) {
                    _vm.accessType = $$v
                  },
                  expression: "accessType",
                },
              }),
              _c("span", { staticClass: "option-label" }, [
                _vm._v(_vm._s(_vm.$t("SPECIFIC_OPTION"))),
              ]),
            ],
            1
          ),
          _vm.$i18n.locale === "en"
            ? [
                _c("p", { staticClass: "mr_25 desc" }, [
                  _vm._v(
                    "\n                  User has access to all tiles content based on the\n              "
                  ),
                ]),
                _c("p", { staticClass: "mr_25 desc" }, [
                  _vm._v("authorised client entities."),
                ]),
              ]
            : [
                _c("p", { staticClass: "mr_25 desc" }, [
                  _vm._v(
                    "\n                  用户可以访问所授权实体在各功能版块中的内容。  \n              "
                  ),
                ]),
              ],
        ],
        2
      ),
      _c(
        "el-option",
        { attrs: { label: _vm.$t("TAILORED_OPTION"), value: "TAILORED" } },
        [
          _c(
            "p",
            [
              _c("el-radio", {
                staticClass: "mr_10 label-hidden",
                attrs: { label: "TAILORED" },
                model: {
                  value: _vm.accessType,
                  callback: function ($$v) {
                    _vm.accessType = $$v
                  },
                  expression: "accessType",
                },
              }),
              _c("span", { staticClass: "option-label" }, [
                _vm._v(_vm._s(_vm.$t("TAILORED_OPTION"))),
              ]),
            ],
            1
          ),
          _vm.$i18n.locale === "en"
            ? [
                _c("p", { staticClass: "mr_25 desc" }, [
                  _vm._v(
                    "\n              User has access to the assigned role(s),which is  \n          "
                  ),
                ]),
                _c("p", { staticClass: "mr_25 desc" }, [
                  _vm._v("based on the tailored access to specific titles and"),
                ]),
                _c("p", { staticClass: "mr_25 desc" }, [
                  _vm._v("authorised client entities."),
                ]),
              ]
            : [
                _c("p", { staticClass: "mr_25 desc" }, [
                  _vm._v(
                    "\n                  用户可以访问所分配“角色”中配置的权限内容。  \n              "
                  ),
                ]),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }